module.exports = __webpack_public_path__ + "static/media/volcano.502b574f.svg";